import AuthenticationRoutes from "@/router/authentication-routes"
import protectedRoutes from "@/router/protected-routes"
import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router"

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
    meta: {
      auth: true,
      breadcrumb: "navbar.home",
      requireAuthentication: true
    },
    children: protectedRoutes
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/404.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.access_token) next({ path: "/" })
      else next({ path: "/login" })
    }
  },
  AuthenticationRoutes
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuthentication && !localStorage.access_token)
    next({ name: "Logout" })
  else next()
})

export default router
